import React from "react";
import { Button, Modal, notification, Form } from "antd";
import { get } from "lodash";
import {
  CREATE_ARTWORK_CATEGORY,
  UPDATE_ARTWORK_CATEGORY,
} from "../../graphql/mutation/artworkCategoryMutation";
import CategoryForm from "./CategoryForm";
import { useMutation } from "@apollo/client";

const CategoryArtworkModal = ({
  showAddNewTo,
  visible,
  title,
  setShowAddNew,
  showRename,
  setShowRename,
  showAddNew,
  categories,
  refetch,
}) => {
  const [form] = Form.useForm();
  const [CreateArtworkCategory, { loading }] = useMutation(
    CREATE_ARTWORK_CATEGORY
  );
  const [UpdateArtworkCategory, { loading: updateLoading }] = useMutation(
    UPDATE_ARTWORK_CATEGORY
  );
  const onSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        if (showAddNew === true) {
          form.resetFields();
          CreateArtworkCategory({
            variables: {
              ...values,
            },
          })
            .then((res) => {
              if (res) {
                notification.success({
                  message: `The Category Reconnected Successfully!`,
                });
                setShowAddNew(false);
                refetch();
              }
            })
            .catch((err) => {
              notification.error({ message: err.message });
            });
        }
        if (showRename !== null) {
          form.resetFields();
          UpdateArtworkCategory({
            variables: {
              ...values,
              id: get(showRename, "id", null),
            },
          })
            .then((res) => {
              if (res) {
                notification.success({
                  message: `The Category Reconnected Successfully!`,
                });
                setShowRename(null);
              }
            })
            .catch((err) => {
              get(err, notification.error({ message: err.message }), null);
            });
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };
  return (
    <div>
      <Modal
        className="p-modal-form-category"
        visible={visible}
        title={title}
        onCancel={() => {
          setShowAddNew(false);
          setShowRename(null);
          form.resetFields();
        }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setShowAddNew(false);
              setShowRename(null);
              form.resetFields();
            }}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading || updateLoading}
            onClick={(e) => onSubmit(e)}
          >
            Save
          </Button>,
        ]}
      >
        {visible && (
          <CategoryForm
            categories={categories}
            id={showRename && showRename.id}
            key={showRename && showRename.id}
            form={form}
            showAddNewTo={showAddNewTo}
            showRename={showRename}
            onSubmit={() => onSubmit()}
          />
        )}
      </Modal>
    </div>
  );
};

export default CategoryArtworkModal;
